'use client';

import Link from '@eliadmin/core/src/components/link';

import type { Menu } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { usePathname } from 'next/navigation';

export function Navigation({
  menu,
  type,
  className,
  isReallyScrolled,
}: {
  menu: Menu;
  type: 'header' | 'footer';
  isReallyScrolled?: boolean;
  className?: string;
}) {
  const pathname = usePathname();
  const slug = pathname.split('/')[1];

  return (
    <div className={cn('flex items-center gap-2', className)}>
      {menu.fields.map((field, index) => {
        const isHomepage = pathname === ROUTES.HOME();
        const isDynamicPage = pathname === ROUTES.DYNAMIC({ slug });

        const isActive = isHomepage ? index === 0 : pathname === field?.path;

        const isScrolled = isReallyScrolled || isDynamicPage;

        return (
          <Link
            key={field.name}
            href={field?.path ?? ''}
            className={cn(
              'flex h-12 items-center justify-center gap-2 rounded-full px-4 text-sm font-medium tracking-tighter transition-all lg:h-[52px] lg:text-base',
              type === 'header' && isActive && 'cursor-context-menu bg-white text-black',
              type === 'header' && isActive && isScrolled && 'bg-black text-white',
              type === 'header' &&
                !isActive &&
                'cursor-pointer bg-white/20 text-white hover:bg-white/40',
              type === 'header' &&
                !isActive &&
                isScrolled &&
                'bg-[#F2F2F2] text-black hover:bg-[#F2F2F2]/80',
              type === 'footer' && 'bg-[#F2F2F2] text-black hover:bg-[#F2F2F2]/80',
            )}
          >
            {isActive && type === 'header' && (
              <div className="max-h-2 min-h-2 min-w-2 max-w-2 rounded-full bg-primary" />
            )}
            {field.name}
          </Link>
        );
      })}
    </div>
  );
}
